import {
  Autocomplete,
  Box,
  Collapse,
  InputLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import * as labels from "config.labels";
import * as staticDataService from "services/staticDataService";
import { useTranslator } from "store/hooks/staticDataHooks";

const NewYorkFreeTradeZone = ({ state, onChange }) => {
  const { isActive, riskCode, comment } = state ?? {};
  const { data: config, isLoading } = staticDataService.useConfigQuery(
    "regulatory_exemptions"
  );

  const translateLabel = useTranslator("uiLabels");

  return (
    <>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <InputLabel>
          {translateLabel(labels.NEW_YORK_FREE_TRADE_ZONE_LABEL, {
            default: "New York Free Trade Zone",
          })}
        </InputLabel>
        <Switch
          checked={isActive ?? false}
          onChange={(e) => {
            onChange &&
              onChange({
                newYorkFreeTradeZone: {
                  isActive: e.target.checked,
                  riskCode: null,
                  comment: null,
                },
              });
          }}
        />
      </Stack>
      <Collapse in={isActive ?? false}>
        <Stack marginTop={1} gap={2}>
          <Autocomplete
            options={config?.nyftzClassCodes ?? []}
            value={
              config?.nyftzClassCodes.find((x) => x.key === riskCode) ?? null
            }
            onChange={(_, value) => {
              onChange &&
                onChange({
                  newYorkFreeTradeZone: {
                    isActive,
                    riskCode: value?.key ?? null,
                    comment,
                  },
                });
            }}
            getOptionKey={({ key }) => key}
            getOptionLabel={({ key, label }) => `${key}: ${label}`}
            renderOption={(props, option) => {
              const { key, ...optionProps } = props;
              return (
                <Box key={key} {...optionProps}>
                  <Stack alignItems={"flex-start"}>
                    <Typography variant={"caption"} color={"grey"}>
                      {option.key}
                    </Typography>
                    <Typography sx={{ marginTop: "-0.25rem" }}>
                      {option.label}
                    </Typography>
                  </Stack>
                </Box>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                type={"text"}
                variant={"filled"}
                label={translateLabel(
                  labels.NEW_YORK_FREE_TRADE_ZONE_RISK_CODE,
                  {
                    default: "Risk Code",
                  }
                )}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            )}
            disabled={isLoading}
          />
          <TextField
            type={"text"}
            InputLabelProps={{ shrink: true }}
            label={translateLabel(labels.NEW_YORK_FREE_TRADE_ZONE_COMMENT, {
              default: "Comment",
            })}
            variant={"filled"}
            onChange={(e) => {
              onChange &&
                onChange({
                  newYorkFreeTradeZone: {
                    isActive,
                    riskCode,
                    comment: e.target.value === "" ? null : e.target.value,
                  },
                });
            }}
            value={comment || ""}
            fullWidth
            multiline
            rows={3}
          />
        </Stack>
      </Collapse>
    </>
  );
};

export default NewYorkFreeTradeZone;
